import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../../services/api';
import FloorList from './FloorList';
import BudgetSetup from './BudgetSetup';
import ProjectPerformance from './ProjectPerformance';
const ProjectDetail = () => {
  const { projectId } = useParams();
  const navigate = useNavigate();
  const [project, setProject] = useState(null);
  const [floors, setFloors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState('floors'); // floors, budgets, performance

  useEffect(() => {
    fetchProjectData();
  }, [projectId]);

  const fetchProjectData = async () => {
    try {
      const [projectRes, floorsRes] = await Promise.all([
        api.get(`/projects/${projectId}`),
        api.get(`/project/${projectId}/floors`)
      ]);
      
      setProject(projectRes.data);
      setFloors(floorsRes.data);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching project data:', error);
      setLoading(false);
    }
  };

  if (loading) return <div className="loading">Loading project...</div>;

  return (
    <div className="project-detail">
      <div style={{ marginBottom: '20px', display: 'flex', justifyContent: 'space-between', marginLeft: '2rem' }}>
        <h2>{project.name}</h2>
        <button onClick={() => navigate('/projects')} className="secondary">
          Back to Projects
        </button>
      </div>

      <div className="tabs" style={{ marginBottom: '20px', marginLeft: '2rem' }}>
        <button 
          className={activeTab === 'floors' ? 'primary' : 'secondary'}
          onClick={() => setActiveTab('floors')}
        >
          Floors
        </button>
        <button 
          className={activeTab === 'budgets' ? 'primary' : 'secondary'}
          onClick={() => setActiveTab('budgets')}
          style={{ marginLeft: '10px' }}
        >
          Budget Setup
        </button>
        <button 
          className={activeTab === 'performance' ? 'primary' : 'secondary'}
          onClick={() => setActiveTab('performance')}
          style={{ marginLeft: '10px' }}
        >
          Performance
        </button>
      </div>

      {activeTab === 'floors' && (
        <FloorList 
          projectId={projectId} 
          floors={floors} 
          onUpdate={fetchProjectData} 
        />
      )}
      
      {activeTab === 'budgets' && (
        <BudgetSetup 
          projectId={projectId} 
          floors={floors}
          onUpdate={fetchProjectData}
        />
      )}
      
      {activeTab === 'performance' && (
        <ProjectPerformance projectId={projectId} />
      )}
    </div>
  );
};

export default ProjectDetail;